export default __webpack_public_path__ + "static/media/0.3b571d4e.mp3";